export enum OtherInfoEnum{
OtherMedicines="1",
Vitamins = "2",
Allergies="3",
SurgicalHistories="4"



}